import axios from "axios";
import {getConfig} from "./utility";

const initialState = {
    importStatistics: [],
    importStatisticsDetails:[],
    fetchingImportStatistics: false,
    fetchingSingle: false
};


const IMPORTSTATISTICS_FETCH = "IMPORTSTATISTICS_FETCH";
const IMPORTSTATISTICS_FIND = "IMPORTSTATISTICS_FIND";
const SEARCH = "SEARCH";

export default (state = initialState, action) => {
    switch (action.type) {
        case IMPORTSTATISTICS_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingImportStatistics: true};
                case 1:
                    return {...state, importStatistics: action.importStatistics, fetchingImportStatistics: false};
                default:
                    return {...state, fetchingImportStatistics: false}
            }
            case SEARCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSingle: true};
                case 1:
                    return {...state, importStatistics: action.importStatistics, fetchingSelections: false};
                default:
                    return {...state, fetchingSingle: false}
            }
            case IMPORTSTATISTICS_FIND:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSingle: true};
                case 1:
                    return {...state, importStatisticsDetails: action.importStatisticsDetails, fetchingSingle: false};
                default:
                    return {...state, fetchingSingle: false}
            }


        default:
            return state
    }
}
const getImportStatisticsReq = () => ({type: IMPORTSTATISTICS_FETCH, status: 0});
const getImportStatisticsSuc = importStatistics => ({type: IMPORTSTATISTICS_FETCH, status: 1, importStatistics});
const getImportStatisticsErr = error => ({type: IMPORTSTATISTICS_FETCH, status: -1, error});
export const getImportStatistics = () => (dispatch, getState) => {
    dispatch(getImportStatisticsReq());
    return axios.get('/import', getConfig(getState))
    .then(res => { console.log('IMPORT!!!!', res); return res;})
        .then(res => dispatch(getImportStatisticsSuc(res.data)))
        .catch(err => dispatch(getImportStatisticsErr(err)))
};
const searchImportStatisticsReq = request => ({type: SEARCH, status: 0, request});
const searchImportStatisticsSuc = importStatistics => ({type: SEARCH, status: 1, importStatistics});
const searchImportStatisticsErr = error => ({type: SEARCH, status: -1, error});
export const search = (request) => (dispatch, getState) => {
    dispatch(searchImportStatisticsReq(request));
    return axios.post('/import/search', request, getConfig(getState))
        .then(res => dispatch(searchImportStatisticsSuc(res.data)))
        .catch(err => dispatch(searchImportStatisticsErr(err)))
};
/**
 * Get detailed imports
 */
const getImportStatisticsDetailsReq = (id) => ({type: IMPORTSTATISTICS_FIND, status: 0, id});
const getImportStatisticsDetailsSuc = importStatisticsDetails => ({type: IMPORTSTATISTICS_FIND, status: 1, importStatisticsDetails});
const getImportStatisticsDetailsErr = error => ({type: IMPORTSTATISTICS_FIND, status: -1, error});
export const getImportStatisticsDetails = (id) => (dispatch, getState) => {
    dispatch(getImportStatisticsDetailsReq(id));
    return axios.get(`/import/${id}`, getConfig(getState))
        .then(res => dispatch(getImportStatisticsDetailsSuc(res.data)))
        .catch(err => dispatch(getImportStatisticsDetailsErr(err)))
};


// WEBPACK FOOTER //
// ./src/js/reducers/import.js